import React from 'react';

const PostBlock = (props: any) => {
  return <div className={`post-block ${props.type}`}>{props.children}</div>;
};
export default PostBlock;
